import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import AllSubscriptionGrid from '../../organisms/AllSubscriptions';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flex: 1
  }
}));

const AllSubscriptions = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <AllSubscriptionGrid></AllSubscriptionGrid>
    </div>
  );
}

export default AllSubscriptions;